var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrencies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4113 8.30556C10.8928 6.19023 12.7904 4.61111 15.0579 4.61111C17.6894 4.61111 19.8226 6.73776 19.8226 9.36111C19.8226 11.7911 17.9923 13.7949 15.631 14.0771M7.23481 6.72222L9.35245 4.61111L7.23481 2.5M2.99951 8.83333V7.42593C2.99951 5.87135 4.26365 4.61111 5.82304 4.61111H7.94069M16.7642 17.2778L14.6466 19.3889L16.7642 21.5M20.9995 15.1667V16.5741C20.9995 18.1287 19.7354 19.3889 18.176 19.3889H16.0583M12.5289 15.6944C12.5289 18.3178 10.3957 20.4444 7.76422 20.4444C5.13274 20.4444 2.99951 18.3178 2.99951 15.6944C2.99951 13.0711 5.13274 10.9444 7.76422 10.9444C10.3957 10.9444 12.5289 13.0711 12.5289 15.6944Z",
    stroke: "#C1C5CF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencies);
export default __webpack_public_path__ + "static/media/Currencies.71b0cc4d8af85a7eeed24b23c204f53f.svg";
export { ForwardRef as ReactComponent };